import { Formula, FormulaRecord } from 'services/store/ai/types';

export const formulaToRecord = (formula: Formula): FormulaRecord =>
  formula.reduce<FormulaRecord>(
    (acc, { field, value }) => ({
      ...acc,
      [field]: value,
    }),
    {}
  );
